// Belge geçerlilik kontrolü: bugüne ve talep bitiş tarihine göre süresi dolan onaylı belgeler
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../ui/alert-dialog';
import { CalendarClock, X } from 'lucide-react';

const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
export const fmtTr = (iso) => (iso ? String(iso).slice(0, 10).split('-').reverse().join('.') : '-');

const validityOf = (docs, key, suffix = '_validity') => {
  const v = docs?.[`${key}${suffix}`] || (key === 'mesleki_yeterlilik' ? docs?.[`${key}_date`] : null);
  return v ? String(v).slice(0, 10) : null;
};

// Onaylı ve geçerlilik tarihi bugünden veya talep bitişinden önce olan belgeler
export const findExpiring = (entity, docDefs, endDate, suffix) => {
  const limit = [todayIso(), endDate || ''].sort().pop();
  return docDefs.flatMap(d => {
    const v = validityOf(entity?.documents, d.key, suffix);
    if (entity?.documents?.[d.key] !== 'onay' || !v || v >= limit) return [];
    return [{ key: d.key, label: d.label, validity: v, expiredNow: v < todayIso() }];
  });
};

// Hâlâ geçerli belgeler içinde en erken bitiş: talep bu tarihe kadar seçilirse tüm belgeler geçerli kalır
export const latestSafeDate = (entities, getDefs, suffix) => {
  const today = todayIso();
  const dates = entities.flatMap(e => (typeof getDefs === 'function' ? getDefs(e) : getDefs).map(d => (e?.documents?.[d.key] === 'onay' ? validityOf(e.documents, d.key, suffix) : null))).filter(v => v && v >= today);
  return dates.length ? dates.sort()[0] : null;
};

export const ValidityDialog = ({ prompt, onYes, onNo, onClose, busy }) => (
  <AlertDialog open={!!prompt} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent className="max-w-xl" data-testid="validity-dialog">
      <button type="button" onClick={onClose} title={prompt?.entry ? 'Kapat ve Çalışma İzinleri sayfasına dön' : 'Kapat'} className="absolute right-3 top-3 rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700" data-testid="validity-dialog-close">
        <X className="h-4 w-4" />
      </button>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2 text-rose-700"><CalendarClock className="h-5 w-5" />Belge geçerlilik süresi doluyor</AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="space-y-3 text-sm text-slate-600">
            <p data-testid="validity-dialog-message">
              Talep girdiğiniz tarih aralığında{' '}
              <span className="whitespace-nowrap text-lg font-bold text-rose-600" data-testid="validity-dialog-range">({prompt?.range})</span>{' '}
              {prompt?.texts.join(' ')} Devam etmek için güncel evrakları yükleyiniz ya da talep tarihini belgelerin geçerlilik süresi içerisinde olacak şekilde değiştiriniz.
            </p>
            <div className="space-y-2 rounded-md border border-rose-200 bg-rose-50 p-3 text-rose-700" data-testid="validity-dialog-list">
              {prompt?.sections.map(sec => (
                <div key={sec.id} data-testid={`validity-section-${sec.id}`}>
                  <p className="font-semibold text-rose-800">{sec.title}</p>
                  <ul className="mt-0.5 space-y-0.5 pl-2">{sec.lines.map((l, i) => <li key={i}>• {l}</li>)}</ul>
                </div>
              ))}
            </div>
            {(prompt?.safeCompany || prompt?.safeEmployee || prompt?.safeEquipment) && (
              <p className="rounded-md border border-emerald-200 bg-emerald-50 p-3 text-emerald-800" data-testid="validity-dialog-suggestion">
                Öneri: Tüm evrakların geçerli olacağı en son tarih
                {prompt.safeCompany && <> firma belgeleri için <b>{fmtTr(prompt.safeCompany)}</b></>}
                {prompt.safeCompany && prompt.safeEmployee && ','}
                {prompt.safeEmployee && <> personel evrakları için <b>{fmtTr(prompt.safeEmployee)}</b></>}
                {(prompt.safeCompany || prompt.safeEmployee) && prompt.safeEquipment && ','}
                {prompt.safeEquipment && <> iş ekipmanı belgeleri için <b>{fmtTr(prompt.safeEquipment)}</b></>} tarihidir.
              </p>
            )}
            <p className="text-xs text-slate-500">"Evet" derseniz bu belgeler kaldırılır ve yeniden yüklenmesi beklenir. "Hayır" derseniz talep tarihini değiştirmek için Bölüm 1'e yönlendirilirsiniz.{prompt?.entry && ' X ile kapatırsanız Çalışma İzinleri sayfasına dönersiniz.'}</p>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={(e) => { e.preventDefault(); onNo(); }} data-testid="validity-dialog-no">Hayır, tarihi değiştireceğim</AlertDialogCancel>
        <AlertDialogAction onClick={(e) => { e.preventDefault(); onYes(); }} disabled={busy} className="bg-rose-600 hover:bg-rose-700" data-testid="validity-dialog-yes">Evet, belgeleri güncelleyeceğim</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
